import { Buffer } from 'buffer';
import * as CryptoJS from 'crypto-js';

export class EncryptionDecryption {
    num: any = {
        0: 'a',
        1: 'b',
        2: 'c',
        3: 'd',
        4: 'e',
        5: 'f',
        6: 'g',
        7: 'h',
        8: 'i',
        9: 'j',
    };
    char: any = {
        a: 0,
        b: 1,
        c: 2,
        d: 3,
        e: 4,
        f: 5,
        g: 6,
        h: 7,
        i: 8,
        j: 9,
    };
    encrypt(that: any) {
        const keyTrans = CryptoJS.enc.Utf8.parse('8080808080808080');
        const ivTrans = CryptoJS.enc.Utf8.parse('8080808080808080');
        const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(JSON.stringify(that)), keyTrans, {
            keySize: 128 / 8,
            iv: ivTrans,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });
        const changestheformat = encrypted.toString();
        const changestheforma1 = changestheformat.split('+').join('-');
        const changestheforma2 = changestheforma1.split('/').join('_');
        return changestheforma2;
    }

    decrypt(data: string) {
        const changestheforma1 = data?.split('-').join('+');
        const changestheforma2 = changestheforma1?.split('_').join('/');
        if (changestheforma2) {
            const key = CryptoJS.enc.Utf8.parse('8080808080808080');
            const iv = CryptoJS.enc.Utf8.parse('8080808080808080');
            const decrypted = CryptoJS.AES.decrypt(changestheforma2, key, {
                keySize: 128 / 8,
                iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            });
            const finalResult = decrypted.toString(CryptoJS.enc.Utf8);
            return finalResult;
        } else {
            return '{}';
        }
    }

    encryptInBase64(data: any): any {
        return Buffer.from(data, 'utf-8').toString('base64');
    }
    decryptFromBase64(data: any): any {
        return Buffer.from(data, 'base64').toString('utf-8');
    }

    encryptionIds(body: any) {
        const str: any = body.toString();
        let res = '';
        for (let i of str) {
            res += this.num[i];
        }
        return res;
    }

    decryptionIds(body: any) {
        let res = '';
        for (let i of body) {
            res += this.char[i];
        }
        return res;
    }
}
